import React from 'react';
import type { AriaRole, CSSProperties, HTMLAttributes } from 'react';
import { StyleSheet, type StyleProp, type TextStyle } from 'react-native';

interface MdiIconWebProps extends Omit<HTMLAttributes<HTMLElement>, 'color' | 'role' | 'style'> {
  name: string;
  size?: number;
  color?: string;
  style?: StyleProp<TextStyle>;
  testID?: string;
  accessibilityRole?: string;
  allowFontScaling?: boolean;
}

const MdiIconWeb: React.FC<MdiIconWebProps> = ({
  name,
  size = 24,
  color = '#000',
  style,
  testID,
  accessibilityRole,
  allowFontScaling,
  ...otherProps
}) => {
  // Flatten React Native style arrays to CSS object
  const flattenedStyle = StyleSheet.flatten([
    {
      fontSize: size,
      color,
      width: size,
      height: size,
      lineHeight: `${size}px`,
      display: 'inline-block',
    },
    style,
  ]);

  // Convert RN style to CSS-compatible (remove undefined values)
  const cssStyle = Object.entries(flattenedStyle).reduce<CSSProperties>((acc, [key, value]) => {
    if (value !== undefined) {
      (acc as Record<string, unknown>)[key] = value;
    }
    return acc;
  }, {});

  return (
    <i
      className={`mdi mdi-${name}`}
      style={cssStyle}
      data-testid={testID}
      role={accessibilityRole as AriaRole | undefined}
      aria-hidden={!accessibilityRole}
      {...otherProps}
    />
  );
};

export default MdiIconWeb;
